import { Fragment } from 'react';
import {
  ListSubheader,
  MenuItem,
  MenuList,
  Stack,
  Typography,
} from '@rossum/ui/material';
import { useIntl } from '../ComponentsContext';
import { boldText } from './boldText';
import { MenuItemContentField } from './MenuItemContentField';
import { menuListSharedProps } from './shared';
import { SuggesterPopoverMode, VariableCompletion } from './types';

export const MenuListFields = ({
  fieldCompletions,
  setFirstRef,
  onInsert,
  search,
  mode = 'formula',
}: {
  fieldCompletions: VariableCompletion[];
  setFirstRef: React.MutableRefObject<HTMLLIElement | null>;
  onInsert: (value: string) => void;
  search: string;
  mode?: SuggesterPopoverMode;
}) => {
  const intl = useIntl();

  return fieldCompletions.length ? (
    <MenuList {...menuListSharedProps}>
      {fieldCompletions.map((fieldCompletion, index) => {
        const prevCategory = fieldCompletions[index - 1]?.section;

        return (
          <Fragment key={fieldCompletion.value}>
            {!search &&
            (!prevCategory || fieldCompletion.section !== prevCategory) ? (
              <ListSubheader
                key={`${fieldCompletion.section}-subheader`}
                sx={{
                  mt: 1,
                }}
              >
                {fieldCompletion.section}
              </ListSubheader>
            ) : null}
            <MenuItem
              ref={index === 1 ? setFirstRef : undefined}
              onClick={() =>
                onInsert(
                  mode === 'formula'
                    ? `${fieldCompletion.meta}.${fieldCompletion.value}`
                    : `{${fieldCompletion.meta}.${fieldCompletion.value}}`
                )
              }
            >
              <MenuItemContentField
                search={search}
                fieldCompletion={fieldCompletion}
                mode={mode}
              />
            </MenuItem>
          </Fragment>
        );
      })}
    </MenuList>
  ) : (
    <Stack alignItems="center" p={2}>
      <Typography variant="body1" textAlign="center" color="text.primary">
        {intl.formatMessage({
          id: 'features.formulas.suggester.menuListFields.noResults.title',
        })}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {intl.formatMessage(
          {
            id: 'features.formulas.suggester.menuListFields.noResults.description',
          },
          {
            bold: boldText,
            search,
          }
        )}
      </Typography>
    </Stack>
  );
};
